if (!customElements.get('scroll-to-top')) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.footer = null;
      this.button = null;
      this.thresholdPx = 0;
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.footer = document.querySelector('.footer-custom, footer');
      this.button = this.querySelector('.scroll-to-top__button');
      this.thresholdPx = this.getThresholdPx();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.button?.addEventListener('click', this.scrollToTop.bind(this));
      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    parseCssLengthPx(value, fallback = 32) {
      if (!value) return fallback;

      const parsedValue = parseFloat(value);
      if (Number.isNaN(parsedValue)) return fallback;

      if (value.endsWith('rem')) {
        return parsedValue * parseFloat(getComputedStyle(document.documentElement).fontSize);
      }

      return parsedValue;
    }

    getButtonHeightPx() {
      const measuredHeight = this.button?.offsetHeight ?? 0;
      if (measuredHeight > 0) return measuredHeight;

      const cssHeight = getComputedStyle(this).getPropertyValue('--scroll-to-top-button-height').trim();
      return this.parseCssLengthPx(cssHeight, 32);
    }

    getThresholdPx() {
      const thresholdRaw = getComputedStyle(this).getPropertyValue('--scroll-to-top-threshold').trim();
      const thresholdValue = parseFloat(thresholdRaw);
      const buttonHeight = this.getButtonHeightPx();

      return thresholdValue + buttonHeight;
    }

    handleScroll() {
      if (!this.footer) {
        this.classList.toggle('is-visible', window.scrollY > window.innerHeight);
        return;
      }

      const footerTop = this.footer.getBoundingClientRect().top;
      const isFooterTopAtThreshold = footerTop <= window.innerHeight - this.thresholdPx;

      this.classList.toggle('is-visible', isFooterTopAtThreshold);
    }
  }

  customElements.define('scroll-to-top', ScrollToTop);
}
